import { Component, ElementRef, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { NgStyle } from "@angular/common";
import { Router } from "@angular/router";
import { ProgramService } from "../program.service";
import { MessageService } from "primeng/components/common/messageservice";
import { ImportService } from "./import.service";
import { ResponseMessage, ImportValidationError } from "@models/common";

declare var Sifter: any;

@Component({
    selector: "app-import-tool",
    templateUrl: "./import-tool.component.html",
    styleUrls: ["./import-tool.component.css"]
})

export class ImportToolComponent {
    public visible = false;
    public file: File;
    public data: FormData;
    public loading = false;
    public showErrorMessage = false;
    public errorMessage: string;
    public showValidationErrors = false;
    public validationErrors: ImportValidationError[];
    public showSuccess = false;
    public successMessage: string;
    @ViewChild("fileInput") input;

    constructor(private programService: ProgramService, private messageService: MessageService,
        private importService: ImportService, private router: Router) { }

    getFile(event) {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            this.clearMessage();
            let file: File = fileList[0];
            this.file = file;
            let data: FormData = new FormData();
            data.append("import", file, file.name);
            this.data = data;
        } else {
            this.clearInput();
        }
    }

    uploadFile() {
        if (this.data == undefined) {
            return this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please select a file"
            });
        }
        this.clearMessage();
        this.loading = true;
        this.importService.import(this.data).finally(() => this.loading = false).subscribe(
            response => {
                if (response.success) {
                    this.showSuccess = true;
                    this.successMessage = response.message;
                    this.clearInput();
                } else {
                    if (response.message === "NO_FILES") {
                        this.showErrorMessage = true;
                        this.errorMessage = "No files uploaded files were found.";
                    } else if (response.message === "NOT_XLSX") {
                        this.showErrorMessage = true;
                        this.errorMessage = "Import source file must be a .xlsx file.";
                    } else if (response.message === "NO_WORKSHEETS") {
                        this.showErrorMessage = true;
                        this.errorMessage = "File has no worksheets.";
                    } else if (response.message === "FAILED_CONVERSION") {
                        this.showErrorMessage = true;
                        this.errorMessage = "The uploaded file couldn't be parsed. ";
                        this.errorMessage += "Please verify that you are using the import template .xlsx file.";
                    } else if (response.message === "NO_PROGRAMS") {
                        this.showErrorMessage = true;
                        this.errorMessage = "No programs were found in the first worksheet of the uploaded file.";
                    } else if (response.message === "FORMAT_ERRORS") {
                        this.showValidationErrors = true;
                        this.validationErrors = response.importValidationErrors;
                    } else if (response.message === "UNKNOWN_ERROR") {
                        this.showErrorMessage = true;
                        this.errorMessage = "An unknown error occurred. Please try again.";
                    }
                }
            },
            error => console.log(error)
        );
    }

    clearMessage(): void {
        this.showSuccess = false;
        this.successMessage = undefined;

        this.showValidationErrors = false;
        this.validationErrors = undefined;

        this.showErrorMessage = false;
        this.errorMessage = undefined;
    }

    clearInput(): void {
        this.file = undefined;
        this.data = undefined;
        this.input.nativeElement.value = "";

    }
    resetForm(): void {
        this.clearMessage();
        this.clearInput();
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/programs/import-tool/import-tool.component.ts